<template>
  <section class="motive">
    <ModuleSection
      :id="`_${$options.name}`"
      title="Motive"
      icon='<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M0.750 0.750 L15.750 0.750 L15.750 17.250 L0.750 17.250 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M15.75 12.75L0.75 12.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M18.755,6.231l3.982,1.327a.75.75,0,0,1,.474.949l-4.743,14.23a.75.75,0,0,1-.949.474L6.755,19.623" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M5.25,12.75,9.4,6.818A1.5,1.5,0,0,1,11.76,6.69l3.99,4.56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M3.375 5.063 A1.688 1.688 0 1 0 6.751 5.063 A1.688 1.688 0 1 0 3.375 5.063 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>'
    >
      <div
        v-if="$store.getters.isB2b"
        class="grid-2_xs-1-spaceBetween-equalHeight u-grid-small-gutter u-mb-2"
      >
        <div class="col">
          <FancyChooser
            v-if="selectionData.mode && selectionData.card.id"
            @click="$root.$emit('composerModal:open', 'ModalPostcardMotives')"
            :isSelected="selectionData.mode == 1"
          >
            <template v-slot:title>{{ $store.getters.getSelectedPostcard.name.substring(0, 16) }}<slot v-if="$store.getters.getSelectedPostcard.name.length > 16">…</slot></template>
            <template v-slot:description><a>Motiv ändern</a></template>
            <template v-slot:pic>
              <img :src="selectionData.card.src" :alt="$store.getters.getSelectedPostcard.name">
            </template>
          </FancyChooser>

          <FancyChooser
            v-else
            @click="$root.$emit('composerModal:open', 'ModalPostcardMotives')"
            :isSelected="selectionData.mode == 1"
          >
            <template v-slot:title>Motivauswahl</template>
            <template v-slot:description>50 Grußkartenmotive stehen zur Verfügung</template>
            <template v-slot:icon>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="32" width="32"><rect x="0.75" y="0.75" width="17.25" height="17.25" rx="1.5" ry="1.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></rect><line x1="0.75" y1="13.5" x2="18" y2="13.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></line><path d="M7.612,21.205l10.524,2.008a2.046,2.046,0,0,0,2.393-1.625L23.213,7.524a2.046,2.046,0,0,0-1.625-2.393l-.383-.073" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path></svg>
            </template>
          </FancyChooser>
        </div>

        <div class="col">
          <FancyChooser
            @click="selectionData.mode = 2; scrollToComposerSection('_ModulePostcardMessage')"
            :isSelected="selectionData.mode == 2"
            :isDisabled="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.md.min ? false : true"
            :minQuantity="$store.getters.getOrderQtySize.md.min"
          >
            <template v-slot:title>Eigenes Motiv</template>
            <template v-slot:description>Sie designen - wir drucken.<br><span class='fancy-chooser__description small'><small>+{{ humanPrice($store.getters.getPricesOwnMotiveProduct.default_net) }}</small></span></template>
            <template v-slot:icon>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="32" width="32"><g><path d="M16,15.62c.3,3.86,6,1.21,5.56,2.54-2.52,7.48-12.64,5.69-17,1.17A10.9,10.9,0,0,1,4.64,4C8.87-.19,16-.5,19.93,4,27.56,12.86,15.76,12.18,16,15.62Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><circle cx="7.19" cy="13.31" r="1.52" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></circle><circle cx="10.95" cy="18.14" r="1.52" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></circle><circle cx="14.59" cy="5.91" r="1.52" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></circle><circle cx="8.14" cy="7.52" r="1.52" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></circle></g></svg>
            </template>
          </FancyChooser>
        </div>
      </div>

      <Notice v-if="selectionData.mode === 2">
        <p>Nach der Bestellung können Sie uns Ihr Wunschdesign als pdf-Datei im vorgeschriebenen Format (148 x 148 mm) zukommen lassen.</p>
      </Notice>

      <div
        v-if="!$store.getters.isB2b"
        @click="$root.$emit('composerModal:open', 'ModalPostcardMotives')"
        id="_ModulePostcardMotiveGallery"
        class="motive__selection"
        :class="{ '--is-empty' : !selectionData.card.id }"
      >
        <div
          class="motive__card"
          :class="{ '--is-selected' : selectionData.card.id }"
        >
          <div
            class="motive__picture"
          >
            <slot v-if="selectionData.card.id">
              <img :src="$store.getters.getSelectedPostcard.image" :alt="$store.getters.getSelectedPostcard.name">

              <i class="icon icon-check-circle motive__check"></i>
            </slot>

            <slot v-else>
              <div class="motive__placeholder">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="32" width="32"><defs></defs><title>picture-polaroid-landscape</title><rect x="0.75" y="0.75" width="15" height="16.5" rx="0.75" ry="0.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></rect><line x1="15.75" y1="12.75" x2="0.75" y2="12.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></line><path d="M18.755,6.231l3.982,1.327a.75.75,0,0,1,.474.949l-4.743,14.23a.75.75,0,0,1-.949.474L6.755,19.623" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><path d="M5.25,12.75,9.4,6.818A1.5,1.5,0,0,1,11.76,6.69l3.99,4.56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><circle cx="5.063" cy="5.063" r="1.688" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></circle></svg>

                Kein Motiv gewählt
              </div>
            </slot>
          </div>

          <span
            v-if="selectionData.card.id"
            class="motive__name"
          >
            {{ $store.getters.getSelectedPostcard.name }}
          </span>
        </div>

        <Button
          @click="$root.$emit('composerModal:open', 'ModalPostcardMotives')"
          class="motive__btn"
        >
          Motiv wählen
        </Button>
      </div>
    </ModuleSection>
  </section>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import { helperMixin } from '@/mixins/HelperMixin';
import { UiMixin } from '@/mixins/UiMixin';

import Button from '@/components/Common/Button';
import ModuleSection from '@/components/Composer/ModuleSection';
import Notice from '@/components/Composer/Notice';
import FancyChooser from '@/components/Composer/FancyChooser';

export default {
  name: 'ModulePostcardMotive',
  props: ['selectionData'],
  mixins: [logicMixin, helperMixin, UiMixin],
  components: {
    Button,
    ModuleSection,
    Notice,
    FancyChooser
  }
};
</script>

<style lang="scss" scoped>
/**
 * Postcard Motive
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Postcard's motive options
 * @since 2021-08-31
**/

$component: 'motive';

.#{$component} {
  &__selection {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @include margin(0 (- map-get($spacers, 4)) map-get($spacers, 5));
    background: linear-gradient(to right, rgba(255,255,255, 0.7) 0 100%),
                url('~@/assets/images/postcard-motive-placeholder.png') center 26px no-repeat;
    background-size: 496px;
    cursor: pointer;

    &.--is-empty {
      min-height: 100px;
      background: url('~@/assets/images/postcard-motive-placeholder.png') center 24px no-repeat;
      background-size: 496px;
    }
  }

  &__card {
    // @include rfs(9rem, width);
    width: 144px;
    height: auto;
    @include margin-bottom(map-get($spacers, 2));
    text-align: center;
    cursor: pointer;

    &:active {
      .#{$component}__picture {
        transform: scale(0.98);
      }
    }

    &.--is-selected {
      .#{$component} {
        &__picture {
          border-color: $primary;
          box-shadow: 0px 0px 10px rgba($primary, 0.3);
        }

        &__check {
          display: block;
        }

        &__name {
          color: $ink;
          font-weight: $font-weight-bold;
        }
      }
    }
  }

  &__picture {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    @include margin-bottom(map-get($spacers, 3));
    border: 2px solid transparent;
    border-radius: $border-radius-sm;
    background: $white;
    box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);

    img {
      display: block;
      width: 100%;
    }
  }

  &__check {
    display: none;
    width: $font-size-base * 1.6;
    height: $font-size-base * 1.6;
    position: absolute;
    left: 50%;
    @include rfs(- $font-size-base * 0.7, bottom);
    transform: translateX(-50%);
    border: 1px solid $white;
    border-radius: 50%;
    background-color: $white;
    font-size: $font-size-base * 1.5;
    color: $primary;
  }

  &__placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @include padding(map-get($spacers, 1));
    line-height: 1.2rem;
    color: $ink-lighter;

    svg {
      @include margin-bottom(map-get($spacers, 3));
      color: $ink-lightest;
    }
  }

  &__name {
    color: $ink-light;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
